"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShippingDeliveryTime = exports.PackageQuantityStrategy = exports.ExternalAppTypes = exports.AppPaymentTerms = void 0;
var AppPaymentTerms;
(function (AppPaymentTerms) {
    AppPaymentTerms[AppPaymentTerms["NONE"] = 0] = "NONE";
    AppPaymentTerms[AppPaymentTerms["DAYS_7"] = 7] = "DAYS_7";
    AppPaymentTerms[AppPaymentTerms["DAYS_14"] = 14] = "DAYS_14";
    AppPaymentTerms[AppPaymentTerms["DAYS_30"] = 30] = "DAYS_30";
    AppPaymentTerms[AppPaymentTerms["DAYS_45"] = 45] = "DAYS_45";
    AppPaymentTerms[AppPaymentTerms["DAYS_60"] = 60] = "DAYS_60";
    AppPaymentTerms[AppPaymentTerms["DAYS_90"] = 90] = "DAYS_90";
})(AppPaymentTerms = exports.AppPaymentTerms || (exports.AppPaymentTerms = {}));
var ExternalAppTypes;
(function (ExternalAppTypes) {
    ExternalAppTypes["SHOPIFY"] = "shopify";
})(ExternalAppTypes = exports.ExternalAppTypes || (exports.ExternalAppTypes = {}));
var PackageQuantityStrategy;
(function (PackageQuantityStrategy) {
    PackageQuantityStrategy["PACKAGE_SIZE"] = "packageSize";
    PackageQuantityStrategy["MIN_QUANTITY"] = "minQuantity";
})(PackageQuantityStrategy = exports.PackageQuantityStrategy || (exports.PackageQuantityStrategy = {}));
var ShippingDeliveryTime;
(function (ShippingDeliveryTime) {
    ShippingDeliveryTime["SAME_DAY"] = "same_day";
    ShippingDeliveryTime["NEXT_DAY"] = "next_day";
    ShippingDeliveryTime["HOURS_48"] = "48_hours";
    ShippingDeliveryTime["DAYS_3_5"] = "3_5_days";
    ShippingDeliveryTime["DAYS_5_UP"] = "5_up_days";
    ShippingDeliveryTime["PICK_UP"] = "pick_up";
})(ShippingDeliveryTime = exports.ShippingDeliveryTime || (exports.ShippingDeliveryTime = {}));
